import { useEffect, useState } from "react";
import { fetchApprovalData, sendApprovalRequest, sendPayRequest } from "../Api/ExpenseApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ExpenseApproval = () => {
  const [approvals, setApprovals] = useState([]);
  const{user}=useAuth();
  const handleDownloadExcel = () => {
  const formattedData = approvals.map((approval, index) => ({
    "S.No": index + 1,
    "Expense Type": approval?.expenses?.expenseType,
    "Employee Name": approval?.user?.name,
    "Employee ID": approval?.user?.resourceId,
    "Merchant": approval?.expenses?.merchantName,
    "Date": new Date(approval?.expenses?.dateofExpense).toLocaleDateString(),
    "Amount": approval?.expenses?.amountSpent,
    "Currency": approval?.expenses?.currency,
    "Payment Method": approval?.expenses?.paymentMethod,
    "Description": approval?.expenses?.descriptionNotes,
    "Project": `${approval?.project} - ${approval?.expenses?.projectId}`,
    "Status":
      approval?.expenses?.approvalStatus === "W" ? "Waiting" : "Approved",
    "Paid Status": approval?.expenses?.paidStatus ? "Paid" : "Not Paid",
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(file, "Expense_Approval.xlsx");
};
  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchApprovalData(user?.organisationId);
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (expenseId) => {
    try {
      await sendApprovalRequest(expenseId);
      toast.success(`🟢 Expense ${expenseId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  const handlePay= async (expenseId) => {
   try {
      await sendPayRequest(expenseId);
      toast.success(`🟢 Paid Expense ${expenseId} `);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Expense Approval</span>
          <Button
  variant="success"
  onClick={handleDownloadExcel}
  style={{ marginBottom: "10px" }}
>
  Download Excel
</Button>
          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Expense Type</th>
                      <th>Employee Name</th>
                      <th>Employee ID</th>
                      <th>Merchant</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Payment Method</th>
                      <th>Description</th>
                      <th>Project Id</th>
                      <th>Status</th>
                      <th>Paid Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval?.expenses?.expenseType}</td>
                        <td>{approval?.user?.name}</td>
                        <td>{approval?.user?.resourceId}</td>
                        <td>{approval?.expenses?.merchantName}</td>
                        <td>{new Date(approval?.expenses?.dateofExpense).toLocaleDateString()}</td>
                        <td>{approval?.expenses?.amountSpent}</td>
                        <td>{approval?.expenses?.currency}</td>
                        <td>{approval?.expenses?.paymentMethod}</td>
                        <td>{approval?.expenses?.descriptionNotes}</td>
                     <td> {approval?.project} - {approval?.expenses?.projectId}</td>
                        <td className={approval?.expenses?.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {approval?.expenses?.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                           <td>{approval?.expenses?.paidStatus===true?"Paid":"Not Paid"}</td>
                        <td>
                          {approval?.expenses?.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(approval?.expenses?.expenseId)}
                              className="approve-btn"
                               style={{marginLeft:"5px"}}
                            >
                              Approve
                            </Button>
                          )}
                            {approval?.expenses?.paidStatus ===false && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handlePay(approval?.expenses?.expenseId)}
                              className="approve-btn"
                              style={{marginTop:"5px",marginLeft:"5px"}}
                            >
                              Pay
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default ExpenseApproval;
